import BaseQuestionModel from '../BaseQuestionModel'
import { DistributeResponse } from '../Distribute/types'
import { SlidersResponse } from '../Sliders/types'
import { IQuestionModelConstructor, QuestionType, SubQuestionID } from '../types'
import {
  VanKonanQuestionModelTypes,
  IVanKonanQuestionModelState,
  IVanKonanResponseValidation,
  VanKonanSubmitResponse,
  WestendorpResponse
} from './types'

const VanKonanQuestionModel: IQuestionModelConstructor<VanKonanQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<VanKonanQuestionModelTypes, IVanKonanQuestionModelState>({
    questionType: QuestionType.VAN_KONAN,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  model.navigationFrame = [1, model.schema.entities.length + 1]
  return model
}

function submitResponse({ response, questionSchema }: IVanKonanQuestionModelState) {
  const fullResponse: VanKonanSubmitResponse = [...response.westendorpResponse]
  if (response.distributeResponse?.data.length)
    response.distributeResponse.data.forEach(item => fullResponse.push({ id: item.id, v: item.v }))
  if (response.slidersResponse?.data.length)
    response.slidersResponse.data.forEach((item, j) =>
      fullResponse.push({ id: questionSchema.entities[2].matrix_batches[j]?.answers[item.value]?.id })
    )
  return fullResponse
}

function initState(state: IVanKonanQuestionModelState): IVanKonanQuestionModelState {
  state.response = { westendorpResponse: [] }
  state.response.westendorpResponse = state.questionSchema.entities[0].matrix_batches.map<WestendorpResponse[number]>(
    batch => {
      return { id: batch.id, v: null }
    }
  )
  if (state.questionSchema.entities.length > 1) {
    state.response.distributeResponse = {
      data: state.questionSchema.entities[1].matrix_batches.map<DistributeResponse['data'][number]>(batch => {
        return { id: batch.id, v: null }
      }),
      valid: false
    }
  }
  if (state.questionSchema.entities.length > 2) {
    state.response.slidersResponse = {
      data: state.questionSchema.entities[2].matrix_batches.map<SlidersResponse['data'][number]>(batch => {
        return { id: batch.id, value: null }
      }),
      valid: false
    }
  }
  return state
}

function validateResponse({ frame, response }: IVanKonanQuestionModelState): IVanKonanResponseValidation {
  if (!frame) return { valid: true }
  if (1 === frame)
    return {
      valid:
        !response.westendorpResponse.some(item => null === item.v) &&
        response.westendorpResponse.reduce(
          (prev, cur, i) => prev && (!i || response.westendorpResponse[i - 1].v < cur.v),
          true
        )
    }
  const invalidBatches: SubQuestionID[] = []

  if (2 === frame) {
    response.distributeResponse?.data.forEach(item => {
      if (null === item.v && !item.hidden) invalidBatches.push(item.id)
    })
    return {
      valid: !response.distributeResponse?.data.some(item => null === item.v && !item.hidden),
      invalidBatches: invalidBatches
    }
  }
  if (3 === frame) {
    response.slidersResponse?.data.forEach(item => {
      if (null === item.value && !item.hidden) invalidBatches.push(item.id)
    })
    return {
      valid: !response.slidersResponse?.data.some(item => null === item.value && !item.hidden),
      invalidBatches: invalidBatches
    }
  }
  return {
    valid: false
  }
}

export default VanKonanQuestionModel
